import { Badge } from "@/components/ui/badge";
import { ArrowRight } from "lucide-react";
import { useTran } from "@/hooks";
import { formatMetricValue } from "../../domains/dataEntry";

const STATUS_CONFIG = {
  new: {
    label: "New",
    icon: "Plus",
    className:
      "bg-green-100 text-green-700 dark:bg-green-900/30 dark:text-green-400",
  },
  updated: {
    label: "Updated",
    icon: "RefreshCw",
    className:
      "bg-yellow-100 text-yellow-700 dark:bg-yellow-900/30 dark:text-yellow-400",
  },
  unchanged: {
    label: "Unchanged",
    icon: "Minus",
    className: "bg-muted text-muted-foreground",
  },
};

const formatValue = formatMetricValue;

export { STATUS_CONFIG, formatValue };

export function NxmapMatchRow({ match, StatusIcon }) {
  const { t } = useTran();
  const cfg = STATUS_CONFIG[match.syncStatus] || STATUS_CONFIG.new;

  return (
    <div className="flex items-start justify-between px-3 py-2 text-sm gap-3">
      <div className="flex items-start gap-2 min-w-0">
        <StatusIcon
          size={13}
          className={`shrink-0 mt-0.5 ${
            match.syncStatus === "new"
              ? "text-green-500"
              : match.syncStatus === "updated"
                ? "text-yellow-500"
                : "text-muted-foreground"
          }`}
        />
        <div className="min-w-0">
          <div className="flex items-center gap-1.5 flex-wrap">
            <Badge variant="outline" className="font-mono text-xs shrink-0">
              {match.disclosureCode}
            </Badge>
            {match.subEntryGroupIndex !== null && (
              <span className="text-xs text-muted-foreground shrink-0">
                {t("SE{{n}}", { n: match.subEntryGroupIndex + 1 })}
              </span>
            )}
            <Badge className={`text-[10px] px-1.5 py-0 ${cfg.className}`}>
              {t(cfg.label)}
            </Badge>
          </div>
          {match.label && (
            <p className="text-xs text-muted-foreground mt-0.5 truncate">
              {match.label}
            </p>
          )}
        </div>
      </div>
      <div className="text-right shrink-0">
        {match.syncStatus === "updated" ? (
          <div className="flex items-center gap-1.5 text-xs">
            <span className="text-muted-foreground line-through tabular-nums">
              {formatValue(match.existingValue)}
            </span>
            <ArrowRight size={10} className="text-muted-foreground" />
            <span className="font-semibold tabular-nums">
              {formatValue(match.value)}
            </span>
            <span className="font-normal text-muted-foreground">
              {match.valueUnit}
            </span>
          </div>
        ) : (
          <span className="font-semibold tabular-nums">
            {formatValue(match.value)}{" "}
            <span className="font-normal text-muted-foreground text-xs">
              {match.valueUnit}
            </span>
          </span>
        )}
      </div>
    </div>
  );
}
